
import React from 'react';
import PropTypes from 'prop-types';
import { FiExternalLink } from 'react-icons/fi';

export default function ExternalLink({ link, children }) {
  return (
    <a href={link} rel="noopener noreferrer" target="_blank">
      {children}
      <FiExternalLink
        style={{ width: '16px', height: '16px', marginLeft: '4px' }}
      />
    </a>
  );
}

ExternalLink.propTypes = {
  link: PropTypes.string.isRequired,
};